import { Resolve, } from '@angular/router';
import { Injectable } from '@angular/core';
import { I18NService } from './I18NService';

@Injectable()
export class I18NResolver implements Resolve<any> {
	constructor(private i18NService: I18NService) {
	}

	resolve(): Promise<any> {
		return this.i18NService.loadMessages();
	}
}
